/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  preparer_user_id: z.string().uuid(),
  require_material_count: z.number(),
  carried_in_at: z.number().nullable(),
  deleted_at: z.number().nullable(),
  work_id: z.number().nullable(),
  carry_in_location_id: z.number().nullable(),
  received_at: z.number().nullable(),
  temperature: z.number().nullable(),
  humidity: z.number().nullable(),
  receiver_name: z.string().nullable(),
  planned_count: z.number(),
  remarks: z.string().nullable(),
  created_by_user_id: z.string().uuid(),
});
const create = base.extend({
  work_id: base.shape.work_id.optional(),
  carry_in_location_id: base.shape.carry_in_location_id.optional(),
  received_at: base.shape.received_at.optional(),
  temperature: base.shape.temperature.optional(),
  humidity: base.shape.humidity.optional(),
  receiver_name: base.shape.receiver_name.optional(),
  planned_count: base.shape.planned_count.optional(),
  remarks: base.shape.remarks.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  carried_in_at: true,
  deleted_at: true,
  created_by_user_id: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  carried_in_at: true,
  deleted_at: true,
  created_by_user_id: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  preparer_user_id: true,
  created_by_user_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const CarryInBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type CarryInBase = z.infer<typeof base>;
export type CarryInBasePutPayload = z.infer<typeof put>;
export type CarryInBasePatchPayload = z.infer<typeof patch>;
export type CarryInBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type CarryInBaseCreateAttributes = z.infer<typeof create>;
export type CarryInBaseUpdateAttributes = z.infer<typeof update>;
export type CarryInBaseCacheAttributes = z.infer<typeof cache>;
export type CarryInBaseCachesAttributes = z.infer<typeof caches>;